var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.routerLinkTo}},[(_vm.navTheme === 'dark')?_c('img',{attrs:{"src":require("@/assets/img/png/equick.png"),"alt":"logo"}}):_c('img',{attrs:{"src":require("@/assets/img/png/equick.png"),"alt":"logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }